import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  createBoardingPassResult,
  createCheckInFlight,
  createCheckInFlightIdObject,
  createJourney,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';

const journey = createJourney({
  template: {
    journeyElements: [createJourneyElementCommon({
      template: {
        journeyElement: createJourneyElement()
      }
    })],
    flights: [
      createCheckInFlightIdObject({
        template: {
          checkInFlight: createCheckInFlight({
            template: {
              acceptanceStatus: 'opened'
            }
          })
        }
      })
    ]
  }
});

const journeyElementIds = journey.journeyElements.map((je: JourneyElementCommon) => je.id);
/**
 * Deeplink Boarding pass
 * 1 Journey - 1 ADT
 */
export const deeplink1Journey1ADTBP: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse([createBoardingPassResult({
    template: {
      result: 'returnedBoardingPassData',
      journeyElementIds
    }
  })], 201)],
  retrieveJourney: [createMockData(journey)]
};
